jQuery(document).ready(function () {
    if ($('.cloudword').length > 0) {

        /*  add attribute of %2 items */
        $(".cloudword_items:even").addClass('cloudword_items-reverse');
        $(".cloudword_items:odd").addClass('cloudword_items-regular');
        $(".cloudword_items-reverse").attr("dir", 'rtl');
        /* Slide */
        $('.cloudword_items-reverse').slick({
            infinite: true,
            autoplay: true,
            autoplaySpeed: 10,
            centerPadding: '60px',
            speed: 9000,
            slidesToShow: 1,
            cssEase: 'linear',
            variableWidth: true,
            rtl: true,
            arrows: false,

        });

        $('.cloudword_items-regular').slick({
            infinite: true,
            autoplay: true,
            autoplaySpeed: 10,
            centerPadding: '60px',
            speed: 9000,
            slidesToShow: 1,
            cssEase: 'linear',
            variableWidth: true,
            arrows: false,

        });
    }
});

